import { EmpoLogoWithBg } from "icons/EmpoLogoWithBg"
import { Outlet } from "react-router"

export function AuthLayout() {
	return (
		<div className="flex h-screen w-screen">
			<div className="hidden w-1/2 items-center justify-center bg-[url(/sources/assets/login/bg.svg)] bg-cover bg-repeat lg:flex">
				<EmpoLogoWithBg className="size-[300px] shrink-0" />
			</div>
			<div className="flex grow items-center justify-center bg-[url(/sources/assets/login/bg.svg)] bg-cover lg:bg-none">
				<Outlet />
			</div>
		</div>
	)
}
